import {useContext} from 'react'
import {IWakeLockContext, WakeLockContext} from './WakeLock.context'

export const useWakeLockContext = (): IWakeLockContext => {
  return useContext(WakeLockContext)
}
